export function shallowCompare(current: Record<string, any>, next: Record<string, any>, checkProperties: string[]): boolean {
  const { length } = checkProperties;

  for (let index = 0; index < length; index++) {
    if (current[checkProperties[index]] !== next[checkProperties[index]]) {
      return true;
    }
  }

  return false;
}
